export default class Location {

    constructor() {
        this.location = $('#location');
    }

    init() {
        this.location.on('change', this.setShops)
    }

    setShops() {
        let cityId = $('#location').find(":selected").val();

        let url = new URL(apiUrl + '/shops')
        url.search = new URLSearchParams({
            city: cityId
        })

        fetch(url)
            .then(response => response.json())
            .then(data => {
                document.getElementById('location_results').innerHTML = data.data;
            })
    }


}



// WEBPACK FOOTER //
// ./static/js/components/Location.js